module.exports = __webpack_public_path__ + "img/nuevoCupon.f4bf88f2.svg";